import { TicketFilters } from "./ticket-filters";

export class TicketTab {
	name:string = "";
	title:string = "";

	private _setFilters:(filters:TicketFilters)=>void = (filters:TicketFilters) =>{};


	public constructor(name:string, title:string, setFilters?:(filters:TicketFilters)=>void){
		this.name = name;
		this.title = title;
		if (setFilters){
			this._setFilters = setFilters;
		}
	}

	setFilters(filters:TicketFilters){
		filters.attention = false;
		filters.liked = false;
		this._setFilters(filters);
	}

	hasFilters(filters:TicketFilters) {
		let newFilters = new TicketFilters();
		this.setFilters(newFilters);
		//let a = JSON.stringify(newFilters.toJSON());
		//let b = JSON.stringify(filters.toJSON());
		return JSON.stringify(newFilters.toJSON()) != JSON.stringify(filters.toJSON());
	}
}

export const AllDefaultTicketTabs = {
	ALL: new TicketTab("all", "ALLE"),
	ATTENTIONS: new TicketTab("my-attentions", "ATTENTIES", (filters)=>{
		filters.attention = true;
	}),
	LIKED: new TicketTab("liked", "LIKED", (filters)=>{
		filters.liked = true;
	}),
	ASSIGNED: new TicketTab("assigned", "TOEGEWEZEN", (filters)=>{
		filters.assigned = true;
	}),
	MY_TICKETS: new TicketTab("my-tickets", "MIJN TICKETS"),
	TSV2: new TicketTab("tsv2", "TSV2"),
	WFONLINE: new TicketTab("wfonline", "WFONLINE"),
	BOOKMARKED: new TicketTab("bookmarked", "BOOKM.", (filters)=>{
		filters.bookmarked = true;
	}),
	SERVICEPAKKET: new TicketTab("service", "SP"),
};